<te-header *ngIf="showHeaderFooter"></te-header>
<section class="te-content">
    <router-outlet></router-outlet>
</section>
<te-footer *ngIf="showHeaderFooter"></te-footer>
